(() => {
  // 商品ページだけで動かしたいなら次の行を有効化
  // if (!document.body.classList.contains('template-product')) return;

  const apply = () => {
    let changed = false;

    const title = document.querySelector('.jdgm-rev-widg__title');
    if (title && title.textContent.trim() !== 'Reviews') {
      title.textContent = 'Reviews';
      changed = true;
    }

    const empty = document.querySelector('.jdgm-rev-widg__summary-text');
    if (empty && empty.textContent.trim() !== 'Be the first to leave a review.') {
      empty.textContent = 'Be the first to leave a review.';
      changed = true;
    }

    const btn =
      document.querySelector('a.jdgm-write-rev-link') ||
      document.querySelector('.jdgm-btn');

    if (btn && btn.textContent.trim() !== 'Write a review') {
      btn.textContent = 'Write a review';
      changed = true;
    }

    return changed;
  };

  const run = () => {
    let tries = 0;
    const timer = setInterval(() => {
      apply();
      tries += 1;
      if (tries >= 30) clearInterval(timer); // 約6秒で終了
    }, 200);
  };

  document.addEventListener('DOMContentLoaded', () => {
    apply();
    run();
  });
})();
const hidePlaceholderIfReviewsExist = () => {
  const hasReviews = document.querySelector('.jdgm-rev') || document.querySelector('.jdgm-rev__body');
  const ph = document.querySelector('.lurie-reviews-placeholder');
  if (hasReviews && ph) ph.style.display = 'none';
};
document.addEventListener('DOMContentLoaded', () => {
  const hideNoMedia = () => {
    document.querySelectorAll('.jdgm-rev').forEach((rev) => {
      const hasMedia =
        rev.querySelector('.jdgm-rev__pic, .jdgm-rev__media, .jdgm-rev__video, img, video');
      if (!hasMedia) rev.style.display = 'none';
    });
  };

  hideNoMedia();
  const widget = document.querySelector('.jdgm-widget, #judgeme_product_reviews');
  if (widget) new MutationObserver(hideNoMedia).observe(widget, { childList: true, subtree: true });
});